import { render, staticRenderFns } from "./idx-sec.vue?vue&type=template&id=4fd11b18&"
import script from "./idx-sec.vue?vue&type=script&lang=js&"
export * from "./idx-sec.vue?vue&type=script&lang=js&"
import style0 from "./idx-sec.vue?vue&type=style&index=0&lang=stylus&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports